import { MultilingualWidgetConfig } from '../dashboard.widgets.config';

interface MenuCategory {
  key: string;
  en: string;
  de: string;
  items: {
    en: string[];
    de: string[];
  };
}

interface MenuData {
  date: string;
  categories: MenuCategory[];
}

const menuData: MenuData = {
  date: 'March 15',
  categories: [
    {
      key: 'mainCourse',
      en: 'Main Course',
      de: 'Hauptgerichte',
      items: {
        en: ['Grilled Chicken with Vegetables', 'Vegetable Lasagna', 'Salmon with Rice Pilaf'],
        de: ['Gegrilltes Hähnchen mit Gemüse', 'Gemüse-Lasagne', 'Lachs mit Reis-Pilaf'],
      },
    },
    {
      key: 'sides',
      en: 'Sides',
      de: 'Beilagen',
      items: {
        en: ['Garden Salad', 'Roasted Potatoes', 'Steamed Broccoli'],
        de: ['Gartensalat', 'Röstkartoffeln', 'Gedünsteter Brokkoli'],
      },
    },
    {
      key: 'desserts',
      en: 'Desserts',
      de: 'Desserts',
      items: {
        en: ['Fresh Fruit Cup', 'Yogurt Parfait', 'Sugar-Free Pudding'],
        de: ['Frischer Obstbecher', 'Joghurt-Parfait', 'Zuckerfreier Pudding'],
      },
    },
  ],
};

const generateMenuHtml = (language: 'en' | 'de'): string => {
  return `
    <div style="display: flex; flex-direction: column; height: 100%;">
      <div style="margin-bottom: 10px; font-weight: 600; color: #282a32;">
        Today's Menu (${menuData.date})
      </div>
      ${menuData.categories
        .map(
          category => `
          <div style="border-bottom: 1px solid #eff1f6; padding-bottom: 10px; margin-bottom: 10px;">
            <div style="font-weight: 600; color: #686b87;">${category[language]}</div>
            <ul style="margin-top: 8px; padding-left: 20px; color: #282a32;">
              ${category.items[language].map(item => `<li>${item}</li>`).join('')}
            </ul>
          </div>`,
        )
        .join('')}
    </div>`;
};

export const canteenMenuWidget: MultilingualWidgetConfig = {
  id: 'canteen-menu',
  translations: {
    en: {
      title: 'Canteen Menu',
      content: generateMenuHtml('en'),
    },
    de: {
      title: 'Kantinen-Menü',
      content: generateMenuHtml('de'),
    },
  },
  x: 2,
  y: 0,
  w: 2,
  h: 4,
};
